import { render, staticRenderFns } from "./ImsInfoDialog.vue?vue&type=template&id=6af65878&"
import script from "./ImsInfoDialog.vue?vue&type=script&lang=js&"
export * from "./ImsInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports